import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ApiService } from "../../providers/api.service";
import swal from "sweetalert";

@Component({
  selector: "app-payin-rma-details",
  templateUrl: "./payin-rma-details.component.html",
  styleUrls: ["./payin-rma-details.component.css"],
})
export class PayinRmaDetailsComponent implements OnInit {
  RMA_Id: any;
  result_ar: any = [];
  result_ar1: any = [];
  SR_NO: any;
  result: any;

  constructor(
    public dialogRef: MatDialogRef<PayinRmaDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public api: ApiService
  ) {}

  ngOnInit() {
    this.RMA_Id = this.data.RMA_Id;
    this.SR_NO = this.data.SrNo;
    this.GetDetails();
  }

  CloseModel(): void {
    this.dialogRef.close({
      Status: "Model Close",
    });
  }



  popupTitle: string = '';
  popupData: any[] = [];
  isModalOpen: boolean = false;
  searchText: string = '';

  LoadMore(type: string, data: any[]) {
    this.popupTitle = type;
    this.popupData = data;
    this.isModalOpen = true;
  }

  CloseModel1() {
    this.isModalOpen = false;
  }


  

  
  GetDetails() {
    this.api.IsLoading();
    this.api
      .Call(
        `../v2/pay-in/RMA/ViewRMADetailsById?Id=${
          this.RMA_Id
        }&User_Id=${this.api.GetUserId()}`
      )
      .then(
        (result) => {
          this.api.HideLoading();

          if (result["Status"] == true) {
            this.result_ar = result["Data"];
            this.result_ar1[0] = result["Data"][0];
            this.result = result["Data1"];

           
            console.log("Data1",this.result);
          } else {
            this.api.ErrorMsg(result["Message"]);
          }
        },
        (err) => {
          this.api.HideLoading();
          this.api.ErrorMsg(err.message);
        }
      );
  }
}
